export enum WindowMessageEventType {
  TimerStart = 'event-start',
  TimerStop = 'event-stop',
  TimerUpdate = 'event-update',
  SessionDestroy = 'session-destroy',
  NotificationsUnread = 'notifications-unread',
}
